module.exports = __webpack_public_path__ + "img/offer-letter-1.bccb320a.svg";